export default {
  labels: {
    today: 'Oggi',
    pickup_time: 'Orario ritiro',
    on_site_time: 'Orario di servizio',
    delivery_time: 'Orario consegna',
  },
};
